import Vue from 'vue'
import VueRouter from 'vue-router'
import Redirect from "../views/Redirect.vue";
import { getAuth } from "firebase/auth";

Vue.use(VueRouter)

const routes = [
   {
    path: '/',
    name: 'Redirect',
    component: Redirect,
    meta: {
      requiresAuth: false
    }
  },
  // {
  //   path: '/',
  //   name: 'Account',
  //   component: Parents,
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  // {
  //   path: '/login',
  //   name: 'Login',
  //   // Educator id linked
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
  //   meta: {
  //     requiresAuth: false
  //   }
  // },
  // {
  //   path: '/children/:childId',
  //   name: 'Children',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Children.vue'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  // {
  //   path: '/children',
  //   name: 'SelectChild',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/SelectChild.vue'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  // {
  //   path: "/terms",
  //   name: "Terms",
  //   component: () => import(/* webpackChunkName: "about" */ '../components/Forms/Terms.vue'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  // {
  //   path: "/cwa/:childId",
  //   name: "CWA",
  //   component: () => import(/* webpackChunkName: "about" */ '../components/Forms/CWA.vue'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  // // end cwa and enrolment terms
  // // start contacts
  // {
  //   path: "/contacts",
  //   name: "Contacts",
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Contacts.vue'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  // end contacts
  // start bookings
  // {
  //   path: "/select-child",
  //   name: "Select Child",
  //   component: () => import(/* webpackChunkName: "about" */ '../components/Bookings/SelectChild.vue'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  // {
  //   path: "/bookings",
  //   name: "Bookings",
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Bookings.vue'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // },

  // {
  //   path: "/edit-request/booking/:formId",
  //   name: "EditRequest",
  //   component: () => import(/* webpackChunkName: "about" */ '../components/Bookings/EditRequest.vue'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  // {
  //   path: "/new-request/child/:childId",
  //   name: "Booking Request",
  //   component: () => import(/* webpackChunkName: "about" */ '../components/Bookings/BookingRequest.vue'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  // end bookings
 
  
]




const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


// router.beforeEach((to, from, next) => {
//   const authenticatedUser = firebase.auth().currentUser;
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  
//   if ( requiresAuth && ! authenticatedUser ) {
//       alert("You are not authorized to access this area.");
//       next("login");
//   }
//   else {
//       next();
//   }
// });

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const auth = getAuth();
  const currentUser = auth.currentUser;
  if(requiresAuth && !currentUser) {
      next("/")
  } else if(requiresAuth && currentUser) {
      next('/')
  }else{
      next('/')
  }
})

export default router
